// src/components/organization/OrganizationLoader.tsx
import { fetchOrganizations } from '@/api/organizations'
import { queryKeys } from '@/lib/query-keys'
import { useAuthStore } from '@/store/auth'
import { useOrganizationStore } from '@/store/organization'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

export const OrganizationsLoader = () => {
  const setOrganizationState = useOrganizationStore(
    (s) => s.setOrganizationState,
  )
  const hasExternalAuth = useAuthStore((s) => s.hasExternalAuth)
  const externalOrganizationId = useOrganizationStore(
    (s) => s.externalOrganizationId,
  )

  const {
    data: organizations = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: queryKeys.organizations.all(),
    queryFn: fetchOrganizations,
    enabled: hasExternalAuth,
  })

  useEffect(() => {
    console.log('[OrganizationLoader] setOrganizationState with:', {
      organizations,
      isLoading,
      error,
    })
    setOrganizationState({
      organizations,
      isLoading,
      error,
    })
  }, [error, setOrganizationState, organizations, isLoading])

  useEffect(() => {
    if (organizations.length === 0) {
      return
    }

    let organization = organizations[0]

    if (externalOrganizationId) {
      organization =
        organizations.find((o) => o.external_id === externalOrganizationId) ??
        organizations[0]
    }

    setOrganizationState({
      organization,
    })
  }, [externalOrganizationId, organizations, setOrganizationState])

  return null
}
